import loadable from '@loadable/component';

export const Other = loadable(() => import('./index'), {
  resolveComponent: (components) => components.Other,
});
